import { render, staticRenderFns } from "./NormalSubscriptionPaymentsList.vue?vue&type=template&id=4836a840&"
import script from "./NormalSubscriptionPaymentsList.vue?vue&type=script&lang=js&"
export * from "./NormalSubscriptionPaymentsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports